import React, { useState } from "react";
import i18n from "../../lib/i18n";

export default function ProductDetailsPopUp({ data, onClose }) {

  const [loading, setLoading] = useState(false);

  const t = i18n.t.bind(i18n);
  const currentLang = i18n.language;

  const handleImageLoad = () => setLoading(false);

  // Helpers for language
  const titleText =
    currentLang === "en" ? data?.title?.en : data?.title?.ar;

  const descriptionText =
    currentLang === "en" ? data?.description?.en : data?.description?.ar;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="bg-thirdly rounded-2xl shadow-lg lg:w-[40%] md:w-[60%] sm:w-[70%] xs:w-[50%] max-w-4xl p-6 relative overflow-y-auto max-h-[86vh] scrollable">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-500 hover:text-red-500 text-xl"
        >
          ✕
        </button>

        {/* Title */}
        <h2 className="text-2xl flex-1 text-center text-white font-bold mb-3">
          {titleText}
        </h2>

        {/* Image */}
        <div className="relative flex justify-center items-center w-full h-64 sm:h-80">
          {loading && (
            <div className="absolute z-10 bg-black/60 text-white px-4 py-2 rounded">
              Loading...
            </div>
          )}
          <img
            src={data?.main_photo}
            alt="Ad"
            onLoad={handleImageLoad}
            className="w-[500px] h-[300px] object-cover rounded-xl"
          />
        </div>

        {/* Info */}
        <div className="space-y-2 text-white mt-3">
          <div className="ms-2 flex flex-col justify-start items-start gap-2">

            {/* Description */}
            <p>
              <span className="font-semibold">{t("product.description")}: </span>
              {descriptionText}
            </p>

            {/* Category */}
            <p>
              <span className="font-semibold">{t("product.category")}: </span>
              {data?.category}
            </p>

            {/* Sub Category */}
            <p>
              <span className="font-semibold">{t("product.sub_category")}: </span>
              {data?.sub_category}
            </p>

            {/* Price */}
            <p>
              <span className="font-semibold">{t("order.price")}:</span> 
              {data?.price}
            </p>

            {/* Available */}
            <p>
              <span className="font-semibold">{t("product.available")}: </span>
              {data?.available ? t("general.yes") : t("general.no")}
            </p>

            {/* Accept (maybe negotiation?) */}
            <p>
              <span className="font-semibold">{t("product.accept")}: </span>
              {data?.accept ? t("general.yes") : t("general.no")}
            </p>

            {/* Offer */}
            <p>
              <span className="font-semibold">{t("product.offer")}: </span>
              {data?.offer ? t("general.yes") : t("general.no")}
            </p>

            {/* If Offer Exists → show more fields */}
            {data?.offer && (
              <>
                <p>
                  <span className="font-semibold">{t("product.final_price")}: </span>
                  {data?.final_price}
                </p>

                <p>
                  <span className="font-semibold">{t("product.start_time")}: </span>
                  {data?.start_time}
                </p>

                <p>
                  <span className="font-semibold">{t("product.end_time")}: </span>
                  {data?.end_time}
                </p>
              </>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}
